// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-item[data-v-2685db5c]{background-color:#fff;padding:.5rem}", ""]);
// Exports
module.exports = exports;
